import moment, { Moment } from 'moment';
import { ProjectTimelineEvent } from 'components/organisms/resource-management/event-types';
import { useTranslate } from 'hooks/use-translation';

export const projectTimelineTooltip = (
  { startDate, endDate }: Pick<ProjectTimelineEvent, 'startDate' | 'endDate'>,
  relativeDate: Moment,
  translate: ReturnType<typeof useTranslate>,
): string =>
  `<span>${translate('project_dates')}:</span><strong> ${translate(
    'templates.resource_management.tooltips.dates',
    {
      startDay: moment(startDate).diff(relativeDate, 'day'),
      duration: moment(endDate).diff(moment(startDate), 'day') + 1,
    },
  )}</strong>`;
